export default __webpack_public_path__ + "static/media/mail.28704e8f.svg";